module.exports = __webpack_public_path__ + "static/img/daosanL.3afadd16.svg";